const Backbone = require('backbone');
const PricedOptionView = require('app/views/store/pages/products/pricedoption');
const PricedOptionAssociatedProductView = require('app/views/store/pages/products/priced_option_associated_product');
const OptionGroupModel = require('app/models/store/client/product/optiongroup');
const ProductCompositeModel = require('app/models/store/client/product/composite_by_unique_id');
var OptionGroupsView = Backbone.View.extend({
	model: OptionGroupModel,
	el: '.option-group',
	events: {
		'click .js-priced-option-associated-product-help': '_handlePricedOptionAssociateProductHelpClick'
	},
	initialize: function() {
		const self = this,
			identity = this.model.get('identity'),
			models = this.model.options.models || [];

		this.pricedOptions = [];

		models.forEach((optionModel) => {
			optionModel.set('selected', optionModel.get('defaultSelection'));

			self.pricedOptions.push(
				new PricedOptionView({
					model: optionModel
				})
			);
		});

		if (!this._isPreConfigured()) {
			$(`#js-required-${identity}`).removeClass('hide');
		}
	},

	/**
	 * _isPreConfigured - Shortcut for inspecting child priced options and determining whether it's configured
	 * @return {Boolean} If this option group is configured
	 */
	_isPreConfigured: function() {
		var defaultSelection;
		if (this.model.get('required')) {
			defaultSelection = this.model.options.where({
				defaultSelection: true
			});
			return defaultSelection.length === 1;
		} else {
			return true;
		}
	},
	_handleAssociatedProductData: function(productCompositeModel) {
		const associatedProductView = new PricedOptionAssociatedProductView({
			model: productCompositeModel
		});
		associatedProductView.render();
	},
	_handlePricedOptionAssociateProductHelpClick: function(event) {
		event.preventDefault();
		const $linkClicked = $(event.currentTarget),
			productUniqueId = $linkClicked.data('product-unique-id');
		let productComposite = new ProductCompositeModel({
			uniqueId: productUniqueId
		});
		productComposite.fetch({
			success: this._handleAssociatedProductData.bind(this),
			data: {
				nonstock: true
			},
			processData: true
		});
	}
});

module.exports = OptionGroupsView;
